// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uQGBM","toggleWrap":"styles_toggleWrap__3DaLV","content":"styles_content__1OXZw","selectAreaCode":"styles_selectAreaCode__36oGG"};